import { SquareIcon } from "@hugeicons/core-free-icons/index";
import { HugeiconsIcon } from "@hugeicons/react";
import { Stack } from "@mui/material";
import clsx from "clsx";
import { motion } from "framer-motion";
import React, { type FC } from "react";
import "./ExpandIcon.scss";

interface ExpandFolderIconProps {
  expanded: boolean;
  className?: string;
  containerClassName?: string;
  header?: boolean;
}

export const ExpandIcon: FC<ExpandFolderIconProps> = ({
  expanded = false,
  className,
  containerClassName,
}) => {
  const variants = {
    open: { rotate: 0 },
    close: { rotate: [0, 90] },
  };
  return (
    <Stack className={clsx("expand-icon-container", containerClassName)}>
      <HugeiconsIcon
        icon={SquareIcon}
        className={clsx("expand-folder-icon", className)}
      />
      <motion.div
        initial={{ rotate: 0 }}
        variants={variants}
        animate={expanded ? "open" : "close"}
        transition={{ duration: 0.3 }}
        className="expand-state"
      >
        {expanded ? "-" : "+"}
      </motion.div>
    </Stack>
  );
};
